import * as React from "react"
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import backIcon from "../../iconic/arrow-left.svg";
import "./BackButton.css";

interface IBackProp extends ITranslationProps, RouteComponentProps<string> {
}

class BackButton extends React.Component<IBackProp> {
    constructor(props: IBackProp) {
        super(props);

        this.onBackClick = this.onBackClick.bind(this);
    }

    public render() {
        return (
            <a className="btn btn-light back-button" onClick={this.onBackClick}>
                <img src={backIcon} className="button-icon mr-2" />
                {this.props.t("Global.Back")}
            </a>
        );
    }

    private onBackClick(): void {
        this.props.history.goBack();
    }

}

export default withRouter(translateComponent(BackButton));



// WEBPACK FOOTER //
// ./src/core/BackButton/BackButton.tsx